import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/diveIN/step2';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { CTRL_499 } from '../../../validators/499/ctrl499';
import { TypeDescNatureMarcheDivers } from '../models/TypeDescNatureMarcheDivers';
import { DivINControlNames } from '../services/DivINControleNames';

@Component({
	selector: 'app-type-nature-marche-divers',
	templateUrl: './type-nature-marche-divers.component.html'
})
export class TypeNatureMarcheDiversComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeNatureMarcheDivers';
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() descriptionMarche: TypeDescNatureMarcheDivers;

	public step2 = new Step2();

	public rg9 = CTRL_499.id + '_1';

	public readonly travauxValue = RadioCheckBoxEnum.travauxValue;
	public readonly fournituresValue = RadioCheckBoxEnum.fournituresValue;
	public readonly servicesValue = RadioCheckBoxEnum.servicesValue;

	public radioButtonValue: string;
	public radioButtonCtrlName: string;

	constructor() {}

	public ngOnInit() {
		this.parentForm.addControl(this.getStepId() + this.rg9, new FormControl({ rgCtrls: DivINControlNames.getCtrl_499Names_json() }));
		if (this.descriptionMarche?.natureMarche.fournitures === RadioCheckBoxEnum.emptyValue) {
			this.radioButtonValue = this.fournituresValue;
		} else if (this.descriptionMarche?.natureMarche.services === RadioCheckBoxEnum.emptyValue) {
			this.radioButtonValue = this.servicesValue;
		} else {
			this.radioButtonValue = this.travauxValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_travaux';
	}

	public getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}
}
